import { createContext } from "react";

// Contexto que identifica QUAL oficina está usando a ferramenta, e
// (opcionalmente) configuração imposta externamente pelo painel admin.
export const WorkshopContext = createContext({
  workshopId: "oficina-demo",
  workshopName: "Oficina (demonstração)",
  config: null,
});
